import React, { PropTypes, Component } from 'react'
import { ClientProfileDataForm } from './client-profile-form'
import { connect } from 'react-redux'
import { setNotification } from 'state/actions'
import styles from './ClientProfileDataWrapper.scss'
import i18n from 'lib/i18n'

const translate = i18n('profile')

@connect()
export class ClientProfileDataWrapper extends Component {
    constructor(props) {
        super(props)
        this.state = { isEditingMode: false }
        this.handleToggleEdit = this.handleToggleEdit.bind(this)
        this.handleSetNotification = this.handleSetNotification.bind(this)
    }

    handleToggleEdit() {
        this.setState({ isEditingMode: !this.state.isEditingMode })
    }

    handleSetNotification(message, type) {
        const { dispatch } = this.props
        dispatch(setNotification(message, type))
    }

    render() {
        const { children, isModifyClient } = this.props
        const { isEditingMode } = this.state

        if (!isModifyClient) {
            return children // Disable editing for non-modifiable clients
        }

        return (
            <div>
                <div className={styles.headerContainer}>
                    <h2 className={styles.header}>{translate('data')}</h2>
                </div>
                {isEditingMode ? (
                    <ClientProfileDataForm
                        onCancel={this.handleToggleEdit}
                        onSubmitData={this.handleSetNotification}
                    />
                ) : (
                    <div>
                        <div className={styles.actionsContainer}>
                            <button
                                className={styles.toggleEditBtn}
                                onClick={this.handleToggleEdit}
                            >
                                {translate('edit_profile')}
                            </button>
                        </div>
                        {children}
                    </div>
                )}
            </div>
        )
    }
}
ClientProfileDataWrapper.propTypes = {
    dispatch: PropTypes.func,
    isModifyClient: PropTypes.bool,
    children: PropTypes.node, // View component
}




// WEBPACK FOOTER //
// ./components/easinsure/client-profile/ClientProfileDataWrapper.jsx